module.exports = __webpack_public_path__ + "img/hand-top.0cb3a9df.png";